import { PresentationView as IPresentationView } from "@cma/presentation-generation-logic";
import { Footer } from "@cma/chat-widgets/cma/components/presentation-sections/Footer";
import { PresentationViewSectionRenderer } from "./PresentationViewSectionRenderer";
import { PhotoGalleryWrapper } from "@cma/chat-widgets/cma/components/PhotoGalleryWrapper";
import { PresentationDisplayMode } from "@cma/chat-widgets/cma/components/presentation-sections/PresentationSectionProps";
import styled from "@emotion/styled";

const Container = styled.div<{ $displayMode?: PresentationDisplayMode }>`
  ${(p) =>
    p.$displayMode === "print" &&
    `
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 2rem;
  background-color: transparent;
  box-sizing: border-box;
  margin: 1rem auto;
`}

  @media print {
    gap: 0;
    margin: 0;
    padding: 0;
  }
`;

interface Props {
  displayMode: PresentationDisplayMode;
  presentationView: IPresentationView;
  printChunkSectionId?: string | null;
}

export const PresentationView = (props: Props) => {
  const { displayMode, presentationView, printChunkSectionId } = props;
  const { sections, galleries, agent } = presentationView;

  const sectionsToDisplay = printChunkSectionId
    ? sections.filter((s) => s.id === printChunkSectionId)
    : sections;

  return (
    <Container $displayMode={displayMode}>
      {sectionsToDisplay.map((sectionView) => {
        const presentationSection = sectionsToDisplay.find(
          (s) => s.id === sectionView.id,
        );

        if (!presentationSection) {
          return null;
        }

        return (
          <PresentationViewSectionRenderer
            agent={agent}
            sectionView={sectionView}
            galleries={galleries}
            displayMode={displayMode}
            key={sectionView.id}
          />
        );
      })}
      {displayMode !== "print" && (
        <Footer updatedAt={presentationView.updatedAt} />
      )}
      {displayMode !== "print" && <PhotoGalleryWrapper />}
    </Container>
  );
};
